import Z, { useRef as I, useCallback as ue, useEffect as ee, useMemo as ie, useDebugValue as ae, createContext as fe, useContext as le } from "react";
const B = Symbol(), de = Symbol(), H = Symbol();
let Se = (e, i) => new Proxy(e, i);
const C = Object.getPrototypeOf, N = /* @__PURE__ */ new WeakMap(), te = (e) => e && (N.has(e) ? N.get(e) : C(e) === Object.prototype || C(e) === Array.prototype), A = (e) => typeof e == "object" && e !== null, q = /* @__PURE__ */ new WeakMap(), K = (e) => e[H] || e, ne = (e, i, u) => {
  if (!te(e))
    return e;
  const c = K(e), f = ((s) => Object.isFrozen(s) || Object.values(Object.getOwnPropertyDescriptors(s)).some((l) => !l.writable))(c);
  let o = u && u.get(c);
  return o && o[1].f === f || (o = ((s, l) => {
    const p = { f: l };
    let h = !1;
    const g = (n, t) => {
      if (!h) {
        let r = p.a.get(s);
        r || (r = /* @__PURE__ */ new Set(), p.a.set(s, r)), t && r.has(B) || r.add(n);
      }
    }, S = { get: (n, t) => t === H ? s : (g(t), ne(n[t], p.a, p.c)), has: (n, t) => t === de ? (h = !0, p.a.delete(s), !0) : (g(t), t in n), getOwnPropertyDescriptor: (n, t) => (g(t, !0), Object.getOwnPropertyDescriptor(n, t)), ownKeys: (n) => (g(B), Reflect.ownKeys(n)) };
    return l && (S.set = S.deleteProperty = () => !1), [S, p];
  })(c, f), o[1].p = Se(f ? ((s) => {
    let l = q.get(s);
    if (!l) {
      if (Array.isArray(s))
        l = Array.from(s);
      else {
        const p = Object.getOwnPropertyDescriptors(s);
        Object.values(p).forEach((h) => {
          h.configurable = !0;
        }), l = Object.create(C(s), p);
      }
      q.set(s, l);
    }
    return l;
  })(c) : c, o[0]), u && u.set(c, o)), o[1].a = i, o[1].c = u, o[1].p;
}, pe = (e, i) => {
  const u = Reflect.ownKeys(e), c = Reflect.ownKeys(i);
  return u.length !== c.length || u.some((f, o) => f !== c[o]);
}, re = (e, i, u, c) => {
  if (Object.is(e, i))
    return !1;
  if (!A(e) || !A(i))
    return !0;
  const f = u.get(K(e));
  if (!f)
    return !0;
  if (c) {
    const s = c.get(e);
    if (s && s.n === i)
      return s.g;
    c.set(e, { n: i, g: !1 });
  }
  let o = null;
  for (const s of f) {
    const l = s === B ? pe(e, i) : re(e[s], i[s], u, c);
    if (l !== !0 && l !== !1 || (o = l), o)
      break;
  }
  return o === null && (o = !0), c && c.set(e, { n: i, g: o }), o;
}, Ee = (e) => te(e) && e[H] || null, $ = (e, i = !0) => {
  N.set(e, i);
}, Oe = (e, i) => {
  const u = [], c = /* @__PURE__ */ new WeakSet(), f = (o, s) => {
    if (c.has(o))
      return;
    A(o) && c.add(o);
    const l = A(o) && i.get(K(o));
    l ? l.forEach((p) => {
      f(o[p], s ? [...s, p] : [p]);
    }) : s && u.push(s);
  };
  return f(e), u;
};
function ye(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var oe = { exports: {} }, U = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F;
function he() {
  if (F)
    return U;
  F = 1;
  var e = Z;
  function i(S, n) {
    return S === n && (S !== 0 || 1 / S === 1 / n) || S !== S && n !== n;
  }
  var u = typeof Object.is == "function" ? Object.is : i, c = e.useState, f = e.useEffect, o = e.useLayoutEffect, s = e.useDebugValue;
  function l(S, n) {
    var t = n(), r = c({ inst: { value: t, getSnapshot: n } }), d = r[0].inst, E = r[1];
    return o(function() {
      d.value = t, d.getSnapshot = n, p(d) && E({ inst: d });
    }, [S, t, n]), f(function() {
      return p(d) && E({ inst: d }), S(function() {
        p(d) && E({ inst: d });
      });
    }, [S]), s(t), t;
  }
  function p(S) {
    var n = S.getSnapshot;
    S = S.value;
    try {
      var t = n();
      return !u(S, t);
    } catch {
      return !0;
    }
  }
  function h(S, n) {
    return n();
  }
  var g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? h : l;
  return U.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : g, U;
}
var j = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k;
function _e() {
  return k || (k = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Z, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function u(O) {
      {
        for (var a = arguments.length, _ = new Array(a > 1 ? a - 1 : 0), R = 1; R < a; R++)
          _[R - 1] = arguments[R];
        c("error", O, _);
      }
    }
    function c(O, a, _) {
      {
        var R = i.ReactDebugCurrentFrame, L = R.getStackAddendum();
        L !== "" && (a += "%s", _ = _.concat([L]));
        var b = _.map(function(D) {
          return String(D);
        });
        b.unshift("Warning: " + a), Function.prototype.apply.call(console[O], console, b);
      }
    }
    function f(O, a) {
      return O === a && (O !== 0 || 1 / O === 1 / a) || O !== O && a !== a;
    }
    var o = typeof Object.is == "function" ? Object.is : f, s = e.useState, l = e.useEffect, p = e.useLayoutEffect, h = e.useDebugValue, g = !1, S = !1;
    function n(O, a, _) {
      g || e.startTransition !== void 0 && (g = !0, u("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var R = a();
      if (!S) {
        var L = a();
        o(R, L) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), S = !0);
      }
      var b = s({
        inst: {
          value: R,
          getSnapshot: a
        }
      }), D = b[0].inst, T = b[1];
      return p(function() {
        D.value = R, D.getSnapshot = a, t(D) && T({
          inst: D
        });
      }, [O, R, a]), l(function() {
        t(D) && T({
          inst: D
        });
        var ce = function() {
          t(D) && T({
            inst: D
          });
        };
        return O(ce);
      }, [O]), h(R), R;
    }
    function t(O) {
      var a = O.getSnapshot, _ = O.value;
      try {
        var R = a();
        return !o(_, R);
      } catch {
        return !0;
      }
    }
    function r(O, a, _) {
      return a();
    }
    var d = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", E = !d, y = E ? r : n, m = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : y;
    j.useSyncExternalStore = m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), j;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = he() : e.exports = _e();
})(oe);
const ge = /* @__PURE__ */ ye(oe.exports), se = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("VERSION") : Symbol(), v = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("LISTENERS") : Symbol(), M = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("SNAPSHOT") : Symbol(), W = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("HANDLER") : Symbol(), P = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("PROMISE_RESULT") : Symbol(), z = ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" ? Symbol("PROMISE_ERROR") : Symbol(), x = /* @__PURE__ */ new WeakSet();
function Ae(e) {
  return x.add(e), e;
}
const V = (e) => typeof e == "object" && e !== null, Re = (e) => V(e) && !x.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), Y = /* @__PURE__ */ new WeakMap();
let J = 1;
const Q = /* @__PURE__ */ new WeakMap();
function G(e = {}) {
  if (!V(e))
    throw new Error("object required");
  const i = Y.get(e);
  if (i)
    return i;
  let u = J;
  const c = /* @__PURE__ */ new Set(), f = (n, t = ++J) => {
    u !== t && (u = t, c.forEach((r) => r(n, t)));
  }, o = /* @__PURE__ */ new Map(), s = (n) => {
    let t = o.get(n);
    return t || (t = (r, d) => {
      const E = [...r];
      E[1] = [n, ...E[1]], f(E, d);
    }, o.set(n, t)), t;
  }, l = (n) => {
    const t = o.get(n);
    return o.delete(n), t;
  }, p = (n, t) => {
    const r = Q.get(t);
    if ((r == null ? void 0 : r[0]) === u)
      return r[1];
    const d = Array.isArray(n) ? [] : Object.create(Object.getPrototypeOf(n));
    return $(d, !0), Q.set(t, [u, d]), Reflect.ownKeys(n).forEach((E) => {
      const y = Reflect.get(n, E, t);
      if (x.has(y))
        $(y, !1), d[E] = y;
      else if (y instanceof Promise)
        if (P in y)
          d[E] = y[P];
        else {
          const m = y[z] || y;
          Object.defineProperty(d, E, {
            get() {
              if (P in y)
                return y[P];
              throw m;
            }
          });
        }
      else
        y != null && y[v] ? d[E] = y[M] : d[E] = y;
    }), Object.freeze(d);
  }, h = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e)), g = {
    get(n, t, r) {
      return t === se ? u : t === v ? c : t === M ? p(n, r) : t === W ? g : Reflect.get(n, t, r);
    },
    deleteProperty(n, t) {
      const r = Reflect.get(n, t), d = r == null ? void 0 : r[v];
      d && d.delete(l(t));
      const E = Reflect.deleteProperty(n, t);
      return E && f(["delete", [t], r]), E;
    },
    is: Object.is,
    canProxy: Re,
    set(n, t, r, d) {
      var E;
      const y = Reflect.has(n, t), m = Reflect.get(n, t, d);
      if (y && this.is(m, r))
        return !0;
      const O = m == null ? void 0 : m[v];
      O && O.delete(l(t)), V(r) && (r = Ee(r) || r);
      let a;
      return (E = Object.getOwnPropertyDescriptor(n, t)) != null && E.set ? a = r : r instanceof Promise ? a = r.then((_) => (a[P] = _, f(["resolve", [t], _]), _)).catch((_) => {
        a[z] = _, f(["reject", [t], _]);
      }) : r != null && r[v] ? (a = r, a[v].add(s(t))) : this.canProxy(r) ? (a = G(r), a[v].add(s(t))) : a = r, Reflect.set(n, t, a, d), f(["set", [t], r, m]), !0;
    }
  }, S = new Proxy(h, g);
  return Y.set(e, S), Reflect.ownKeys(e).forEach((n) => {
    const t = Object.getOwnPropertyDescriptor(
      e,
      n
    );
    t.get || t.set ? Object.defineProperty(h, n, t) : S[n] = e[n];
  }), S;
}
function Me(e) {
  return V(e) ? e[se] : void 0;
}
function De(e, i, u) {
  ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" && !(e != null && e[v]) && console.warn("Please use proxy object");
  let c;
  const f = [], o = (s) => {
    if (f.push(s), u) {
      i(f.splice(0));
      return;
    }
    c || (c = Promise.resolve().then(() => {
      c = void 0, i(f.splice(0));
    }));
  };
  return e[v].add(o), () => {
    e[v].delete(o);
  };
}
function X(e) {
  return ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" && !(e != null && e[M]) && console.warn("Please use proxy object"), e[M];
}
function Ve(e) {
  return ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" && !(e != null && e[W]) && console.warn("Please use proxy object"), e[W];
}
const { useSyncExternalStore: ve } = ge, me = (e, i) => {
  const u = I();
  ee(() => {
    u.current = Oe(e, i);
  }), ae(u.current);
};
function Te(e, i) {
  const u = i == null ? void 0 : i.sync, c = I(), f = I();
  let o = !0;
  const s = ve(
    ue(
      (h) => {
        const g = De(e, h, u);
        return h(), g;
      },
      [e, u]
    ),
    () => {
      const h = X(e);
      try {
        if (!o && c.current && f.current && !re(
          c.current,
          h,
          f.current,
          /* @__PURE__ */ new WeakMap()
        ))
          return c.current;
      } catch {
      }
      return h;
    },
    () => X(e)
  );
  o = !1;
  const l = /* @__PURE__ */ new WeakMap();
  ee(() => {
    c.current = s, f.current = l;
  }), ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0 } && "production") !== "production" && me(s, l);
  const p = ie(() => /* @__PURE__ */ new WeakMap(), []);
  return ne(s, l, p);
}
const w = G({
  header: !1,
  spotlight: !1,
  discovery: !1,
  toggleHeader() {
    w.header = !w.header;
  },
  toggleSpotlight() {
    w.spotlight = !w.spotlight;
  },
  toggleDiscovery() {
    w.discovery = !w.discovery;
  }
}), we = {
  dashboardLoader: w
}, Le = G(we), be = fe(Le), Ue = () => le(be);
export {
  be as GlobalContext,
  Me as getVersion,
  G as proxy,
  Ae as ref,
  X as snapshot,
  Le as store,
  De as subscribe,
  Ve as unstable_getHandler,
  Ue as useGlobalState,
  Te as useSnapshot
};
